import React, { useEffect, useState } from "react";
import { Image } from "react-feather";
import AttachmentPreviewModal from "../../../components/common/AttachmentPreviewModal";
import { useGetAlarmPhotoQuery } from "../alarmsApi";
import { formatTime } from "../alarmFormat";

// One thumbnail. Photos are authenticated, so each is fetched as a Blob and shown
// through an object URL that is released when the thumbnail goes away.
const Thumb = ({ recordGuid, photo, onOpen }) => {
  const { data: blob, isError } = useGetAlarmPhotoQuery({ recordGuid, photoGuid: photo.recordGuid });
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!blob) return undefined;
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  return (
    <button
      type="button"
      className="btn p-0 border rounded overflow-hidden position-relative"
      style={{ width: 150, height: 112, background: "#F1F3F5" }}
      disabled={!blob}
      onClick={() => onOpen(blob, photo)}
      title={`Uploaded ${formatTime(photo.uploadedDate)}${photo.uploadedByName ? ` by ${photo.uploadedByName}` : ""}`}
    >
      {url ? (
        <img src={url} alt={photo.originalFileName} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <span className="d-flex h-100 align-items-center justify-content-center text-muted small">
          {isError ? "Could not load" : <Image size={20} />}
        </span>
      )}
      <span
        className="position-absolute bottom-0 start-0 end-0 text-white small px-1"
        style={{ background: "rgba(0,0,0,.55)", fontSize: 11 }}
      >
        {formatTime(photo.uploadedDate)}
      </span>
    </button>
  );
};

const AlarmPhotoGallery = ({ recordGuid, photos }) => {
  const [preview, setPreview] = useState(null);

  if (!photos?.length) return <p className="text-muted small mb-0">No photos yet.</p>;

  return (
    <>
      <div className="d-flex flex-wrap gap-2">
        {photos.map((p) => (
          <Thumb key={p.recordGuid} recordGuid={recordGuid} photo={p} onOpen={(blob, photo) => setPreview({ blob, photo })} />
        ))}
      </div>
      <small className="text-muted d-block mt-2">
        Camera photos; the server&apos;s time is stamped onto each one when it is uploaded.
      </small>
      <AttachmentPreviewModal
        show={!!preview}
        onClose={() => setPreview(null)}
        blob={preview?.blob}
        fileName={preview?.photo.originalFileName}
        title={preview ? `Photo - ${formatTime(preview.photo.uploadedDate)}` : ""}
      />
    </>
  );
};

export default AlarmPhotoGallery;
